export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M14.93 3.23h-.01A3.99 3.99 0 0010.61.02C8.53.22 7 2.08 7 4.17V6H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h10c.56 0 1-.45 1-1V7c0-.55-.44-1-1-1H8V4c0-1.66 1.34-3 3-3s3 1.34 3 3v.5c0 .28.22.5.5.5s.5-.22.5-.5V4c0-.26-.03-.52-.07-.77zM11 7v8H1V7h10z\" clip-rule=\"evenodd\"/><path d=\"M6 13c-.28 0-.5-.22-.5-.5v-2c0-.28.22-.5.5-.5s.5.22.5.5v2c0 .28-.22.5-.5.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "15",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 15 16"
  }
};